module.exports = __webpack_public_path__ + "static/media/tathagata_small.b1482865.jpg";